var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticClass:"w-100 px-3",attrs:{"src":_vm.preview},on:{"click":function($event){return _vm.viewer(_vm.images)}}})}
var staticRenderFns = []

export { render, staticRenderFns }